<template lang="html">
    <ModalDefault
        v-if="params.isActive"
        size="s"
        :with-content="true"
        @close="no();"
        :theme="true"
        :fix-height="false"
        :fix-width="false"
        :loading="false"
    >
        <template slot="main">
            <p class="modal-title">{{ $t("common.download") }}</p>

            <span>{{ $t("catalogForecast.market.warningDownload") }}</span>
            <div class="table-responsive my-4">
                <table>
                    <tr v-for="download in params.downloads">
                        <td>{{ download.by.firstname + " " + download.by.lastname }}</td>
                        <td class="text-center">{{ moment(download.date).format($t("common.dateTimeFormat")) }}</td>
                    </tr>
                </table>
            </div>
            <span>{{ $t("catalogForecast.market.warningDownload2") }}</span>

            <div class="row mt-5">
                <div class="col d-flex justify-content-center">
                    <ClientColorButton :inactiveColor="true" @click="no();" class="mr-4"> {{ $t("wishlist.btNo") }} </ClientColorButton>
                    <ClientColorButton :background-color="currentBrand.linksColor" @click="yes();"> {{ $t("wishlist.btYes") }} </ClientColorButton>
                </div>
            </div>
        </template>
    </ModalDefault>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import * as moment from "moment/moment";
import {mapState} from "vuex";

export default {
    components: {DefaultTextareaInputBloc, ModalDefault},
    props: ['params'],
    data () {
        return {
            moment
        }
    },
    methods: {
        no() {
            this.params.isActive = false;
            this.$emit('no');
        },
        yes() {
            this.params.isActive = false;
            this.$emit('yes');
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    }
}
</script>

<style scoped lang="scss">
span {
    font-size: 16px;
    text-transform: initial;
}
.table-responsive {
    max-height: 338px;
    overflow: auto;
    table {
        width: 100%;
        tr {
            td {
                border: 1px solid #2d2d2d;
                padding: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// DownloadInfos.vue?8a1e22e0